import url from 'libraries/front-end-core/core/url'
import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { CURRENT_AWARENESS } from 'constants/controllers'

export default new Controller({
  name: 'LegacyNewsArchiveRedirect',
  route: ':aol/ca(/browse/:fromDate/:toDate)(/id/:id)',
  controller (Router, { params }) {
    const target = url(CURRENT_AWARENESS, params)
    replaceUrl(target)
  }
})
